import { useQuery } from "@tanstack/react-query";
import { fetchCoinsNew } from "api/coin-api";
import { userDataStore } from "store";
var useCoinsData = function () {
    var userBalances = userDataStore(function (state) { var _a; return (_a = state.user) === null || _a === void 0 ? void 0 : _a.coinBalances; });
    return useQuery({
        queryKey: ["coins", userBalances],
        queryFn: function () { return fetchCoinsNew(userBalances || []); },
        staleTime: Infinity,
        placeholderData: function (prev) { return prev; },
    });
};
export default useCoinsData;
